import { CheckmarkIcon } from '@curology/ui-components-web/react/Icon/icons/CheckmarkIcon';
import { CrossIcon } from '@curology/ui-components-web/react/Icon/icons/CrossIcon';
import React from 'react';

import { type FlashMessageProps } from '@/atoms/flashMessages/flashMessagesState';
import { type Brand } from '@/consts/brands';
import { UpsellService } from '@/services/upsellService/client';

export const centsToDollarsAndCents = (amountInCents: number) => {
  return (amountInCents / 100).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });
};

export const getSwipeDirection = (
  currentIndex: number,
  nextIndex: number,
  lastIndex: number,
) => {
  if (currentIndex === 0 && nextIndex === lastIndex) {
    return 'backward';
  }

  if (currentIndex === lastIndex && nextIndex === 0) {
    return 'forward';
  }

  if (currentIndex > nextIndex) {
    return 'backward';
  }

  return 'forward';
};

export const processMultiRxUpsellPage = async ({
  brand,
  upsell,
  accepted,
  onNext,
  flashMessages,
  setFlashMessages,
  setProcessing,
}: {
  brand: Brand;
  upsell: string;
  accepted: boolean;
  onNext: () => void;
  flashMessages: FlashMessageProps[];
  setFlashMessages: React.Dispatch<React.SetStateAction<FlashMessageProps[]>>;
  setProcessing: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  setProcessing(true);

  const { error, message, title } = await UpsellService.processUpsellDecision({
    brand,
    upsell,
    accepted,
  });

  if (error) {
    setFlashMessages([
      ...flashMessages,
      {
        children: 'A server error occurred. Please try again.',
        icon: <CrossIcon />,
        iconSize: 'sm',
        state: 'critical',
        title: 'Sorry!',
      },
    ]);

    setProcessing(false);
  } else if (message && title) {
    setFlashMessages([
      ...flashMessages,
      {
        children: <div dangerouslySetInnerHTML={{ __html: message }} />,
        icon: <CheckmarkIcon />,
        iconSize: 'sm',
        state: 'success',
        title: title,
      },
    ]);

    setTimeout(onNext, 2000);
  } else {
    onNext();
  }
};
